import * as React from "react";
import Svg, { Path } from "react-native-svg";

const TestSectionIcon = (props) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 10.666a2 2 0 1 1 4 0v13.536l-2 3-2-3V10.666ZM26 10a.667.667 0 0 0-.667.666v13.132l.667 1 .667-1V10.667A.667.667 0 0 0 26 10Z"
      fill="#48A9C2"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.333 13.333h-2.666V12h2.666v1.333Zm-20.666-8a1.333 1.333 0 0 0-1.334 1.334v18.666a1.333 1.333 0 0 0 1.334 1.334H20a1.333 1.333 0 0 0 1.333-1.334V6.667A1.333 1.333 0 0 0 20 5.333H6.667ZM4 6.667A2.667 2.667 0 0 1 6.667 4H20a2.667 2.667 0 0 1 2.667 2.667v18.666A2.667 2.667 0 0 1 20 28H6.667A2.667 2.667 0 0 1 4 25.333V6.667Z"
      fill="#48A9C2"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.333 10A.667.667 0 0 1 14 9.334h5.333a.667.667 0 1 1 0 1.333H14a.667.667 0 0 1-.667-.667Zm0 2.667A.667.667 0 0 1 14 12h5.333a.667.667 0 1 1 0 1.334H14a.666.666 0 0 1-.667-.667Zm0 6A.667.667 0 0 1 14 18h5.333a.667.667 0 1 1 0 1.334H14a.666.666 0 0 1-.667-.667Zm0 2.666a.667.667 0 0 1 .667-.666h5.333a.667.667 0 0 1 0 1.333H14a.667.667 0 0 1-.667-.666ZM8 18.668v2h2v-2H8Zm-.667-1.334h3.334a.666.666 0 0 1 .666.667v3.334a.667.667 0 0 1-.666.666H7.333a.667.667 0 0 1-.666-.666V18a.667.667 0 0 1 .666-.666Zm4.472-7.804a.667.667 0 0 1 0 .943L8.667 13.61l-1.805-1.805a.666.666 0 1 1 .943-.943l.862.862 2.195-2.195a.667.667 0 0 1 .943 0Z"
      fill="#48A9C2"
    />
  </Svg>
);

export default TestSectionIcon;
